import React from "react";
import CartItem from "./WishlistItem";
import CartShimmer from "./WishlistShimmer";
const WishlistList = ({ cartItems, loading }) => {
  if (loading) {
    return <CartShimmer />;
  }
  if (!loading && (cartItems?.length ?? 0) === 0) {
    return (
      <p className="p-3 px-5 py-2 text-sm text-gray-500">
        Your Cart is empty. add items to continue
      </p>
    );
  }
  return cartItems.map((item, index) => <CartItem item={item} key={index} />);
};

export default WishlistList;
